// extracted by mini-css-extract-plugin
export default {"wrapper":"MenuHeaderComponent_wrapper__dfADL","line":"MenuHeaderComponent_line__4u3xf","lineEnd":"MenuHeaderComponent_lineEnd__1cIPA"};